import { Component, OnInit } from '@angular/core';
import { EnvironmentService } from 'src/app/services/environment.service';
import { FacilityConfig, WellnessConfig } from 'src/environments/environment.interface';

@Component({
  selector: 'app-wellness',
  templateUrl: './wellness.component.html',
  styleUrls: ['./wellness.component.scss']
})
export class WellnessComponent implements OnInit {
  settings: FacilityConfig;
  wellnessConfig: WellnessConfig;
  constructor(
    _environmentService: EnvironmentService
  ) { 
    this.settings = _environmentService.getFacilityConfig();
    this.wellnessConfig = this.settings.homePage.wellness;
  }

  ngOnInit(): void {
  }

}
